// export const timeOffDurationOptions = [
//   {
//     label: 'timeOff:fullDay',
//     value: '1',
//   },
//   {
//     label: 'timeOff:halfDay',
//     value: '2',
//   },
//   {
//     label: 'timeOff:specificHours',
//     value: '3',
//   },
// ];
// export const payOptions = [
//   {
//     label: 'common:paid',
//     value: '1',
//   },
//   {
//     label: 'common:unpaid',
//     value: '0',
//   },
// ];
// export const dayHourOptions = [
//   {
//     label: 'common:days',
//     value: 'days',
//   },
//   {
//     label: 'common:hours',
//     value: 'hours',
//   },
// ];

export const timeOffDurationOptions = [
  {
    label: 'Full Day',
    value: 'Full Day',
  },
  {
    label: 'First Half Day',
    value: 'First Half Day',
  },
  {
    label: 'Second Half Day',
    value: 'Second Half Day',
  },
  {
    label: 'Specific Hours',
    value: 'Specific Hours',
  },
];

export const payOptions = [
  {
    label: 'Paid',
    value: '1',
  },
  {
    label: 'Unpaid',
    value: '0',
  },
];

export const dayHourOptions = [
  {
    label: 'days',
    value: 'days',
  },
  {
    label: 'hours',
    value: 'hours',
  },
];

export const timeOffRequestStatus = [
  { label: 'All', value: 'All' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Approved', value: 'Approved' },
  { label: 'Declined', value: 'Rejected' },
];
